export abstract class BaseComponent {
    public container;
    public options;

    constructor(container: HTMLElement, options: Record<string, any>) {
        this.container = container;
        this.options = {
            ...this.getDefaultOptions(),
            ...options,
        };
    }

    public onLoad(): void {
        if (!window.location.hash || !this.options.linkable) return;

        const element: HTMLElement = this.container.querySelector(window.location.hash);
        if (element) this.open(element.dataset.componentId)
    }

    public afterOpen(id: string) {
        if (!this.options.linkable) return;
        window.history.pushState({}, '', `#${id}`)
    }

    public afterClose(id: string) {
        if (!this.options.linkable) return;
        if (window.location.hash === `#${id}`) {
            history.pushState('', '', window.location.pathname);
        }
    }

    public getDefaultOptions(options: Record<string, any> = {}): Record<string, any> {
        return {
            linkable: false,
        };
    }

    abstract open(id: string): void;
}
